module.exports = __webpack_public_path__ + "static/media/monthly100_on.2bf8fb29.png";